 

 document.addEventListener('DOMContentLoaded', function() {

  // ----------------------- home banner video play pause ----------------------*
  // const banner = document.getElementById('video-banner');
  //   const video = banner.querySelector('video');
  //   const btn = banner.querySelector('.video-toggle-btn');

  //   function toggleVideo() {
  //     if (video.paused) {
  //       video.play();
  //       btn.classList.remove('paused');
  //     } else {
  //       video.pause();
  //       btn.classList.add('paused');
  //     }
  //   }

  //   banner.addEventListener('click', (e) => {
  //     if (e.target.closest('.video-toggle-btn')) return;
  //     toggleVideo();
  //   });

  //   btn.addEventListener('click', toggleVideo);

  //   document.addEventListener('keydown', (e) => {
  //     if (e.code === 'Space') {
  //       e.preventDefault();
  //       toggleVideo();
  //     }
  //   });


  //---------- header drawer menu Function to show specific menu drawer-----------------*
    // Store the active menu type
    window.activeMenuType = null;
    
    // Function to show specific menu
    window.showMenu = function(menuId) {
      // Hide all menus
      document.querySelectorAll('.menu-content').forEach(menu => {
        menu.style.display = 'none';
      });
      
      // Show the selected menu
      const targetMenu = document.querySelector(`[data-menu-id="${menuId}"]`);
      if (targetMenu) {
        targetMenu.style.display = 'block';
      }
    };
  // });



  // --------------- *********Home page Our Vendor section slider ************ ---------------
  // document.addEventListener('DOMContentLoaded', function () {
      const swiper = new Swiper('.vendorsSwiper', {
        slidesPerView: 4,
        spaceBetween: 38,
        loop: false,
        navigation: {    
          nextEl: '.vendors-next',
          prevEl: '.vendors-prev',
        },
        breakpoints: {
          320: { slidesPerView: 1.2, spaceBetween: 20 },
          768: { slidesPerView: 2, spaceBetween: 20 },
          1024: { slidesPerView: 3.5 },
          1500: { slidesPerView: 4 },
        },
        on: {
          init: function () {
            updateArrowState(this);
          },
          slideChange: function () {
            updateArrowState(this);
          }
        }
      });

      function updateArrowState(swiper) {
        const prev = document.querySelector('.vendors-prev');
        const next = document.querySelector('.vendors-next');
        if (swiper.isBeginning) prev.classList.remove('active');
        else prev.classList.add('active');
        if (swiper.isEnd) next.classList.remove('active');
        else next.classList.add('active');
      }
    // });




  //--------------- Gallery page Load More Button--------
  // document.addEventListener('DOMContentLoaded', function () {
    const items = document.querySelectorAll('.gallery-item');
    const loadMoreBtn = document.getElementById('load-more');
    if (!items.length || !loadMoreBtn) return; // prevent error on other pages

    const itemsPerLoad = 9;
    let currentVisible = 0;

    function showNextItems() {
      for (let i = currentVisible; i < currentVisible + itemsPerLoad; i++) {
        if (items[i]) items[i].classList.remove('hidden');
      }
      currentVisible += itemsPerLoad;
      if (currentVisible >= items.length) loadMoreBtn.style.display = 'none';
    }

    showNextItems();
    loadMoreBtn.addEventListener('click', showNextItems);
});


// trade-in/sell page dimond we sell section slider 
  document.addEventListener('DOMContentLoaded', function() {
    const dimondsSwiper = new Swiper('.dimondsSwiper', {
      slidesPerView: 1,
      spaceBetween: 50,
      loop: false,
      navigation: {
        nextEl: '.dimonds-next',
        prevEl: '.dimonds-prev',
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1500: {
             slidesPerView: 3
        },
      },
      on: {
          init: function () {
            updateArrowState(this);
          },
          slideChange: function () {
            updateArrowState(this);
          }
        }
      
    });
      function updateArrowState(swiper) {
        const prev = document.querySelector('.dimonds-prev');
        const next = document.querySelector('.dimonds-next');
        if (swiper.isBeginning) prev.classList.remove('active');
        else prev.classList.add('active');
        if (swiper.isEnd) next.classList.remove('active');
        else next.classList.add('active');
      }
  });

//--------------- main-product custom-collapsible + quick view box collapsible content------------
   (function () {
  const observers = new WeakMap();

  function closeAll(scope = document) {
    scope.querySelectorAll('.custom-collapsible .collapsible-toggle').forEach(t => t.classList.remove('active'));
    scope.querySelectorAll('.custom-collapsible .collapsible-content').forEach(c => {
      c.classList.remove('open');
      c.style.maxHeight = null;
    });
  }

  function openContent(toggle, content) {
    toggle.classList.add('active');
    content.classList.add('open');
    content.style.maxHeight = content.scrollHeight + 'px';

    if (!observers.has(content)) {
      const ro = new ResizeObserver(() => {
        if (content.classList.contains('open')) {
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
      ro.observe(content);
      observers.set(content, ro);
    }
  }

  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('.collapsible-toggle');
    if (!toggle) return;

    const wrapper = toggle.closest('.custom-collapsible');
    if (!wrapper) return;
    const content = wrapper.querySelector('.collapsible-content');
    if (!content) return;

    const isOpen = content.classList.contains('open');

    // scope inside modal if present, else whole document
    const modal = wrapper.closest('.quick-view, .modal, [data-quick-view], .product-modal');
    const scope = modal || document;

    closeAll(scope);

    if (!isOpen) {
      openContent(toggle, content);
    }
  });

  // Optional: make Enter/Space accessible for button
  // document.addEventListener('keydown', (e) => {
  //   if (e.key === 'Enter' || e.key === ' ') {
  //     const focused = document.activeElement;
  //     if (focused && focused.classList && focused.classList.contains('collapsible-toggle')) {
  //       focused.click();
  //       e.preventDefault();
  //     }
  //   }
  // });

})();

  //------------------- related product slider script---------
  document.addEventListener('DOMContentLoaded', function () {
    function initRelProductSlider(container) {
      var relproductSlider = container.querySelector('.relslide');
      if (relproductSlider && !relproductSlider.classList.contains('splide-initialized')) {
        relproductSlider.classList.add('splide-initialized');

        const splide = new Splide(relproductSlider, {
          type: 'slide',
          perPage: 4,
          perMove: 1,
          gap: '3rem',
          pagination: false,
          arrows: false,
          breakpoints: {
            640: { perPage: 1, gap: '1rem' },
            992: { perPage: 2, gap: '2rem' },
            1200: { perPage: 4, gap: '3rem' },
          },
        });

        const nextBtn = container.querySelector('.related-next');
        const prevBtn = container.querySelector('.related-prev');

        function updateArrowState() {
          if (!prevBtn || !nextBtn) return;
          const index = splide.index;
          const end = splide.Components.Controller.getEnd();

          if (index === 0) prevBtn.classList.remove('active');
          else prevBtn.classList.add('active');

          if (index === end) nextBtn.classList.remove('active');
          else nextBtn.classList.add('active');
        }

        splide.on('mounted move', () => {
          const end = splide.Components.Controller.getEnd() + 1;
          const rate = Math.min((splide.index + 1) / end, 1);
          const progressBarEl = relproductSlider.querySelector('.my-slider-progress-bar');
          if (progressBarEl) progressBarEl.style.width = `${rate * 100}%`;
          updateArrowState();
        });

        splide.mount();

        if (nextBtn) nextBtn.addEventListener('click', () => splide.go('>'));
        if (prevBtn) prevBtn.addEventListener('click', () => splide.go('<'));

        updateArrowState();
      }
    }

    const recommendations = document.querySelector('product-recommendations');
    if (recommendations) {
      const observer = new MutationObserver(() => initRelProductSlider(recommendations));
      observer.observe(recommendations, { childList: true, subtree: true });
    }

    initRelProductSlider(document);

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('product-recommendations')) {
        setTimeout(() => initRelProductSlider(event.target), 100);
      }
    });
  });


  // ------------------ * Footer Marque ****--------------
 document.addEventListener('DOMContentLoaded', function () {
    const swiperContainer = document.querySelector('.marqueeSwiper .swiper-wrapper');
    const slide = swiperContainer.querySelector('.swiper-slide');

    // Clone enough slides to fill viewport width
    const cloneCount = Math.ceil(window.innerWidth / slide.offsetWidth) + 4;
    for (let i = 0; i < cloneCount; i++) {
      swiperContainer.appendChild(slide.cloneNode(true));
    }

    const swiper = new Swiper('.marqueeSwiper', {
      slidesPerView: 'auto',
      spaceBetween: 0,
      loop: true,
      speed: 10000,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      freeMode: true,
      freeModeMomentum: false,
      loopAdditionalSlides: 10,
    });

    swiper.wrapperEl.style.transitionTimingFunction = 'linear';
    
  });

    // --------------- *********Index marque section ************ ---------------
// document.addEventListener('DOMContentLoaded', function () {
//   const marqueeSwiper = new Swiper('.marquee-swiper', {
//     slidesPerView: 'auto',
//     spaceBetween: 42,
//     loop: false, // disable loop
//     allowTouchMove: false, // prevent drag slowdown
//     speed: 8000, // higher = slower scroll
//     autoplay: {
//       delay: 0,
//       disableOnInteraction: false,
//     },
//     freeMode: true,
//     freeModeMomentum: false,
//   });

//   // set continuous linear motion
//   marqueeSwiper.wrapperEl.style.transitionTimingFunction = 'linear';
// });


// PDP tab_custom on product page template- product-customisible
 document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll(".tab-btn");
    const tabs = document.querySelectorAll(".tab-pane");

    buttons.forEach(btn => {
      btn.addEventListener("click", () => {

        // remove active states
        buttons.forEach(b => b.classList.remove("active"));
        tabs.forEach(t => t.classList.remove("active"));

        // activate clicked
        btn.classList.add("active");
        document.getElementById(btn.dataset.tab).classList.add("active");
      });
    });
  });

    //   new Splide('#jewelrySplide', {
    //   type: 'loop',
    //   autoplay: true,
    //   interval: 2000,
    //   speed: 600,
    //   gap: '30px',
    //   perPage: 6, 
    //   pauseOnHover: false,
    //   pauseOnFocus: false,
    //   arrows: false,
    //   pagination: false,
    //   breakpoints: {
    //     1024: { perPage: 3 }, 
    //     580: { perPage: 2 }, 
    //   },
      
    // }).mount();